/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteFragment } from 'relay-runtime';
type Http4xxErrorsRow_issue$ref = any;
import type { FragmentReference } from "relay-runtime";
declare export opaque type Http4xxErrorsTable_project$ref: FragmentReference;
export type Http4xxErrorsTable_project = {|
  +host: string,
  +crawls: ?{|
    +edges: ?$ReadOnlyArray<?{|
      +node: ?{|
        +countCodesHttp4xxErrors: ?$ReadOnlyArray<?{|
          +code: number,
          +count: number,
        |}>,
        +http4xxErrors: ?{|
          +count: number,
          +edges: ?$ReadOnlyArray<?{|
            +node: ?{|
              +$fragmentRefs: Http4xxErrorsRow_issue$ref
            |}
          |}>,
        |},
      |}
    |}>
  |},
  +$refType: Http4xxErrorsTable_project$ref,
|};
*/


const node/*: ConcreteFragment*/ = (function(){
var v0 = {
  "operator": "AND",
  "values": ([]/*: any*/)
},
v1 = {
  "kind": "Variable",
  "name": "errorUrl",
  "variableName": "errorUrl",
  "type": "TextFilters"
},
v2 = {
  "kind": "Variable",
  "name": "linkTypeFilter",
  "variableName": "linkTypeFilter",
  "type": "LinkTypeFilter"
},
v3 = {
  "kind": "Variable",
  "name": "sourceUrl",
  "variableName": "sourceUrl",
  "type": "TextFilters"
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
};
return {
  "kind": "Fragment",
  "name": "Http4xxErrorsTable_project",
  "type": "Project",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "LocalArgument",
      "name": "offset",
      "type": "Int",
      "defaultValue": 0
    },
    {
      "kind": "LocalArgument",
      "name": "limit",
      "type": "Int",
      "defaultValue": 20
    },
    {
      "kind": "LocalArgument",
      "name": "codeFilters",
      "type": "[Int]",
      "defaultValue": []
    },
    {
      "kind": "LocalArgument",
      "name": "errorUrl",
      "type": "TextFilters",
      "defaultValue": v0
    },
    {
      "kind": "LocalArgument",
      "name": "sourceUrl",
      "type": "TextFilters",
      "defaultValue": v0
    },
    {
      "kind": "LocalArgument",
      "name": "linkTypeFilter",
      "type": "LinkTypeFilter",
      "defaultValue": {
        "showInternal": true,
        "showExternal": true
      }
    }
  ],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "host",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "crawls",
      "storageKey": "crawls(limit:1,offset:0)",
      "args": [
        {
          "kind": "Literal",
          "name": "limit",
          "value": 1,
          "type": "Int"
        },
        {
          "kind": "Literal",
          "name": "offset",
          "value": 0,
          "type": "Int"
        }
      ],
      "concreteType": "CrawlsConnection",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "edges",
          "storageKey": null,
          "args": null,
          "concreteType": "CrawlsEdge",
          "plural": true,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "node",
              "storageKey": null,
              "args": null,
              "concreteType": "Crawl",
              "plural": false,
              "selections": [
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "countCodesHttp4xxErrors",
                  "storageKey": null,
                  "args": [
                    v1,
                    v2,
                    v3
                  ],
                  "concreteType": "CountCode",
                  "plural": true,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "alias": null,
                      "name": "code",
                      "args": null,
                      "storageKey": null
                    },
                    v4
                  ]
                },
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "http4xxErrors",
                  "storageKey": null,
                  "args": [
                    {
                      "kind": "Variable",
                      "name": "codeFilters",
                      "variableName": "codeFilters",
                      "type": "[Int]"
                    },
                    v1,
                    {
                      "kind": "Variable",
                      "name": "limit",
                      "variableName": "limit",
                      "type": "Int"
                    },
                    v2,
                    {
                      "kind": "Variable",
                      "name": "offset",
                      "variableName": "offset",
                      "type": "Int"
                    },
                    v3
                  ],
                  "concreteType": "Http4xxErrorsConnection",
                  "plural": false,
                  "selections": [
                    v4,
                    {
                      "kind": "LinkedField",
                      "alias": null,
                      "name": "edges",
                      "storageKey": null,
                      "args": null,
                      "concreteType": "Http4xxErrorsEdge",
                      "plural": true,
                      "selections": [
                        {
                          "kind": "LinkedField",
                          "alias": null,
                          "name": "node",
                          "storageKey": null,
                          "args": null,
                          "concreteType": "Http4xxError",
                          "plural": false,
                          "selections": [
                            {
                              "kind": "FragmentSpread",
                              "name": "Http4xxErrorsRow_issue",
                              "args": null
                            }
                          ]
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
})();
// prettier-ignore
(node/*: any*/).hash = 'b9a13f9e7a0ca92adc4b11eefaeb9620';
module.exports = node;
